import { render, staticRenderFns } from "./JinNangBuy.vue?vue&type=template&id=e567b7ea"
import script from "./JinNangBuy.vue?vue&type=script&lang=js"
export * from "./JinNangBuy.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports